import { Signup } from 'components/pages/login/signup'

function SignupPage(): React.ReactElement {
    return <Signup />
}

export default SignupPage
